"use strict";

angular.module("vendor")
.service("VendorOrderService", function(
    $window, $resource, $http, $cookies, FlashBag, gettextCatalog, common, CoreOrderService, appConfig,
    OrderSelectorUnregisteredServiceFactory
) {
    const LISTING_URL = "/catalog/vendor/orders/list/";

    function VendorOrderService() {
        OrderSelectorUnregisteredServiceFactory.call(this, LISTING_URL);
        var _this = this;

        this.getBulkActionParams = function() {
            var exportOrderResource = $resource(appConfig.API_SERVER + "/catalog/vendor/orders/export/");
            var createInvoiceResource = $resource(appConfig.API_SERVER + "/invoice/vendor/bulk-create/");
            var printOrderResource = $resource(appConfig.API_SERVER + "/catalog/vendor/orders/bulk-action/pdf/print/");
            var emailOrderResource = $resource(appConfig.API_SERVER + "/catalog/vendor/orders/bulk-action/pdf/email/");

            return {
                exportOrder: {
                    text: gettextCatalog.getString("Export Order"),
                    message: gettextCatalog.getString("Do you really want to export these orders?"),
                    resource: exportOrderResource,
                    successMessage: gettextCatalog.getString("Orders were exported successfully."),
                    modalTemplatePrefix: "order",
                    modalTemplatePackage: "vendor"
                },
                createInvoice: {
                    text: gettextCatalog.getString("Create Invoice"),
                    message: gettextCatalog.getString("Do you really want to create invoice with these orders?"),
                    resource: createInvoiceResource,
                    successMessage: gettextCatalog.getString("Invoices were created successfully."),
                    modalTemplatePrefix: "order",
                    modalTemplatePackage: "vendor"
                },
                printOrder: {
                    text: gettextCatalog.getString("Print Order"),
                    message: gettextCatalog.getString("Do you really want to generate pdf of theses orders?"),
                    resource: printOrderResource,
                    successMessage: gettextCatalog.getString("Pdf was created successfully."),
                    modalTemplatePrefix: "order",
                    modalTemplatePackage: "vendor"
                },
                emailOrder: {
                    text: gettextCatalog.getString("Email Order"),
                    message: gettextCatalog.getString("Do you really want to send generated pdf of theses orders by email?"),
                    resource: emailOrderResource,
                    successMessage: gettextCatalog.getString("Email was sent successfully."),
                    modalTemplatePrefix: "email-order",
                    modalTemplatePackage: "vendor",
                    controller: "EmailOrderBulkActionConfirmationController",
                    controllerAs: "emailOrderBulkActionConfirmationCtrl"
                }
            };
        };

        this.getSingleActionParams = function(user) {
            var actions = _this.getBulkActionParams();
            if (
                user && user.vendor && user.vendor.allow_order_modification
            ) {
                actions["modifyOrder"] = {
                    text: gettextCatalog.getString("Modify Order"),
                    method: _this.startOrderModification
                };
            }
            return actions;
        };

        this.getSortFields = function() {
            return common.getSortFieldsByKeys(
                "CreationDate",
                this.getAvailableSortFields()
            );
        };

        this.log = function(order_id, referer) {
            var service = $resource(appConfig.API_SERVER + "/catalog/vendor/orders/logs/", {}, {});
            var params = {
                "order": order_id
            };

            // Adds referer only if it is defined, default is "app"
            if (referer) {
                params["referer"] = referer;
            }
            service.save(params);
        };

        this.startOrderModification = function(orderId) {
            $http({
                method: "POST",
                url: appConfig.API_SERVER + "/catalog/vendor/orders/" + orderId + "/start-modification/"
            }).then(function onSuccess(response) {
                $cookies.put("vendor_orders_url", response.data.vendor_orders_url, {
                    domain: appConfig.ROOT_DOMAIN
                });
                $window.location.href = response.data.customer_cart_url;
            }, function onError(response) {
                FlashBag.apiError(response);
            });
        }
    }

    return new VendorOrderService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/order/vendor-order.service.js
// module id = 888
// module chunks = 0